// Simple AngularJS recursive treeview directive
angular.module('audRoamApp').directive('treeView', [function() {
    return {
        restrict: 'E',
        scope: {
            treeData: '='
        },
        template: `
            <ul class="treeview-list">
                <li ng-repeat="node in treeData">
                    <span ng-click="node.expanded = !node.expanded" style="cursor:pointer">
                        <span ng-if="node.children && node.children.length">
                            <b ng-if="!node.expanded">&#9654;</b><b ng-if="node.expanded">&#9660;</b>
                        </span>
                        {{node.label}}
                    </span>
                    <tree-view ng-if="node.children && node.children.length && node.expanded" tree-data="node.children"></tree-view>
                </li>
            </ul>
        `
    };
}]);
